import clsx from "clsx"
import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StarIcon, Ton3dIcon } from "@/assets"
import { dayjsServer } from "@/helpers/dayjsServer"
import { displayUsername } from "@/helpers/displayUsername"
import { PlayerAvatarV2 } from "@/ui/PlayerAvatarV2"
import { NEW_REFERRAL_THRESHOLD_HOURS } from "../../values"
import styles from "./FriendCard.module.scss"
import type { IFriendCard } from "./types"

export const FriendCard: FC<IFriendCard> = ({ item }) => {
  const { t } = useTranslation()

  const isNew = useMemo(() => {
    if (!item.createdAt) return false
    return (
      dayjsServer().diff(item.createdAt, "hour") < NEW_REFERRAL_THRESHOLD_HOURS
    )
  }, [item.createdAt])

  return (
    <li
      className={clsx(styles.FriendCard, {
        [styles.isNew]: isNew
      })}
    >
      <div className={styles.FriendCard_top}>
        <PlayerAvatarV2
          className={styles.FriendCard_avatar}
          src={item.visibleAvatar}
        />
        <div className={styles.FriendCard_name}>
          {displayUsername(item.visibleUsername)}
        </div>
      </div>
      <div className={styles.FriendCard_earnings}>
        {!!item.tonAvailableToClaim && (
          <div className={styles.FriendCard_earningItem}>
            <Ton3dIcon />
            {item.tonAvailableToClaim}
          </div>
        )}
        {!!item.starsAvailableToClaim && (
          <div className={styles.FriendCard_earningItem}>
            <StarIcon />
            {item.starsAvailableToClaim}
          </div>
        )}
      </div>
      {isNew && (
        <span className={styles.FriendCard_newPill}>
          {t("referrals.friends.card.newLabel")}
        </span>
      )}
    </li>
  )
}
